export enum FileSizeFormat {
  MB = 'mb',
  KB = 'kb',
  B = 'b',
}
